
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/komodo-defi-framework/tutorials/using-komodefi-cli-in-console",
      function () {
        return require("private-next-pages/docs/komodo-defi-framework/tutorials/using-komodefi-cli-in-console/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/komodo-defi-framework/tutorials/using-komodefi-cli-in-console"])
      });
    }
  